var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hamburger hamburger--collapse",class:{ 'is-active': _vm.value },attrs:{"type":"button","aria-label":_vm.value ? 'Fermer le menu' : 'Ouvrir le menu',"aria-controls":"navigation"},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"})])
}]

export { render, staticRenderFns }